// Helper functions for composition component

export function createCanvas(width, height, willReadFrequently=false) 
{
	const canvas = document.createElement('canvas')
	canvas.width = width; canvas.height = height
	const context = canvas.getContext('2d', { willReadFrequently })
	return { canvas, context }
}

export function computeScale(canvasBuffer, cssSize) 
{
	const sx = canvasBuffer.width / Math.max(1, cssSize.w)
	const sy = canvasBuffer.height / Math.max(1, cssSize.h)
	return { sx, sy }
}

export function withCssContext(contextBuffer, canvasBuffer, cssSize, fn) 
{
	const { sx, sy } = computeScale(canvasBuffer, cssSize)
	contextBuffer.save()
	contextBuffer.setTransform(sx, 0, 0, sy, 0, 0)
	try { fn(contextBuffer) } finally { contextBuffer.restore() }
}

export function scanCanvas(contextBuffer, canvasBuffer) 
{
	const { width, height } = canvasBuffer
	if (!width || !height) return true
	const data = contextBuffer.getImageData(0, 0, width, height).data
	const u32 = new Uint32Array(data.buffer)
	for (let i = 0; i < u32.length; i++) {
		if (u32[i] !== 0) return false
	}
	return true
}